import React from "react";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useTranslation from "../../../hooks/useTranslation";

interface Props {
    onUnlock: () => void;
}

export default function DocumentLocked({ onUnlock }: Props) {
    const { t } = useTranslation();

    return (
        <div className="absolute inset-0 z-10 flex h-full w-full flex-col items-center justify-start gap-4 overflow-y-auto bg-surface-2 p-8 pt-20">
            <FontAwesomeIcon icon={faLock} className="text-2xl text-ink-muted" />
            <div className="max-w-md text-center text-sm text-ink-muted">
                {t("pdf_viewer.ask_password.dismissed")}
            </div>
            <button
                type="button"
                autoFocus
                onClick={onUnlock}
                className="flex appearance-none items-center gap-2 rounded-lg! border-0 bg-accent px-4 py-2 text-sm font-medium text-white! transition-colors hover:brightness-110"
            >
                {t("pdf_viewer.ask_password.enter_password")}
            </button>
        </div>
    );
}
